/*
 * Copyright (C) 2019 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * A service for caching the results of server calls.
 */
(function () {
  angular.module('services.cache', []).factory('CacheService', factory);

  /**
   * Builds and returns the CacheService object.
   *
   * @returns {object} - the CacheService object
   */
  function factory() {
    // Each cache entry consists of an expiration time and the promise providing the server call result.
    const cache = {};

    return {
      getResult: getResult
    };

    /**
     * Gets a result from the cache, if present and not expired, or from the server. If the server is called the new
     * result is stored in the cache.
     *
     * @param {String} key - the key under which the result is stored.
     * @param {Function} serverCall - the function returning a promise of the result.
     * @returns {Promise} - the promise of the result of the server call.
     */
    function getResult(key, serverCall) {
      const now = moment();

      // Check the cache for the key.
      let cacheEntry = cache[key];
      if (cacheEntry && cacheEntry.expires) {
        // Make sure the cache entry has not expired
        if (cacheEntry.expires.isBefore(now)) {
          // Discard the cache entry and call the server again.
          cacheEntry = undefined;
        }
      }

      // If there is no cache entry, create one that expires in one hour and contains the results of the server call.
      if (!cacheEntry) {
        cacheEntry = cache[key] = {
          expires: now.clone().add(1, 'hours'),
          promise: serverCall()
        };
      }

      return cacheEntry.promise;
    }
  }
})();
